<template>
  <div>
    <base-header :style="{ background: '#F7F8FD' }" class="py-6">
      <div class="row"></div>
    </base-header>
    <div class="container-fluid">
      <v-app>
        <card>
          <div class="row align-items-center p-3">
            <h2 class="col-6 m-0">User Management</h2>
            <div class="col-6 text-end">
              <v-btn
                class="mx-2"
                fab
                @click.prevent="add = !add"
                dark
                small
                color="#4D4B4B"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </div>
          </div>

          <div class="col-6">
            <v-text-field
              label="Search"
              v-model="search"
              append-icon="mdi-magnify"
            ></v-text-field>
          </div>

          <div class="table-responsive mt-4">
            <base-table
              class="align-items-center"
              thead-classes="thead-light"
              type="hover"
              :data="filteredList"
            >
              <template slot="columns">
                <th v-for="(header, index) in tableHeaders" :key="index">
                  {{ header }}
                </th>
              </template>
              <template slot-scope="{ row, index }">
                <td>{{ index + 1 }}</td>
                <td>{{ row.employee_code }}</td>
                <td>{{ row.username }}</td>
                <td>{{ row.email }}</td>
                <td>{{ row.mobile }}</td>
                <td>
                  <i
                    class="btn fas fa-pen"
                    @click.prevent="editUser(row.id)"
                  ></i>
                  <i
                    class="btn fas fa-trash text-danger"
                    @click.prevent="deleteUser({ row, index })"
                  ></i>
                </td>
              </template>
            </base-table>
          </div>
          <delete-dialog
            :data="filteredList"
            v-model="deleteItemIndex"
            actionString="deleteUser"
            item="user"
            :miscData="{ itemID: selectedItem }"
          >
            <span slot="warning">This user data will be removed! </span>
          </delete-dialog>
        </card>
      </v-app>
    </div>
    <AddUser :dialog.sync="add" />
    <EditUser :dialog.sync="edit" :id.sync="selectedItem" />
  </div>
</template>
<script>
import AddUser from "./AddUser.vue";
import EditUser from "./EditUser.vue";
export default {
  name: "Staffs",
  components: {
    AddUser,
    EditUser,
  },
  data() {
    return {
      add: false,
      edit: false,
      deleteItemIndex: -1,
      selectedItem: null,
      tableHeaders: [
        "SL",
        "Employee ID",
        "Username",
        "Email",
        "Mobile",
        "Actions",
      ],
      filteredList: [],
      search: "",
    };
  },
  methods: {
    editUser(id) {
      this.selectedItem = id;
      this.edit = !this.edit;
    },
    deleteUser({ row, index }) {
      this.deleteItemIndex = index;
      this.selectedItem = row.id;
    },
    fetchUsersList() {
      this.$store.dispatch("fetchUsersList").catch((err) => {
        this.$notify({
          title: "Failed to fetch users list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
  },
  computed: {
    usersList() {
      return this.$store.state.usersStore.users;
    },
  },
  watch: {
    add() {
      this.fetchUsersList();
    },
    edit() {
      this.fetchUsersList();
    },
    usersList() {
      this.filteredList = [...this.usersList];
    },
    search() {
      if (this.search.trim() !== "") {
        this.filteredList = this.usersList.filter((item) =>
          item.username.toUpperCase().includes(this.search.toUpperCase())
        );
      } else {
        this.filteredList = [...this.usersList];
      }
    },
  },
  mounted() {
    this.fetchUsersList();
  },
};
</script>
<style scoped>
.test {
  color: blue;
}

.test:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
